export const tierProgressClassNames = {
  root: 'academy-tier-progress',
  card: 'academy-tier-progress-card',
  item: 'academy-tier-progress-item',
};
